// extracted by mini-css-extract-plugin
export var buyLink = "PlusUpsellNoAuth-module__buyLink___oLX13";
export var container = "PlusUpsellNoAuth-module__container___H14Ha";
export var image = "PlusUpsellNoAuth-module__image___eDyTU";
export var imageAndTextContainer = "PlusUpsellNoAuth-module__imageAndTextContainer___E8wOn";
export var imageContainer = "PlusUpsellNoAuth-module__imageContainer___OHOpe";
export var logoPlusImage = "PlusUpsellNoAuth-module__logoPlusImage___jbF4c";
export var text = "PlusUpsellNoAuth-module__text___h3Bei";
export var textContainer = "PlusUpsellNoAuth-module__textContainer___Iy0B9";
export var title = "PlusUpsellNoAuth-module__title___Cd0yF";